import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import store from './store'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

Sentry.init({
    dsn:
        'https://f80007d0be5240f89e7e6dc73f3c4734@o511220.ingest.sentry.io/5608110',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    release: 'adviserplusservicemanagementmui@' + window.config.BUILD_NUMBER,
    environment: window.config.DEPLOYED_ENVIRONMENT,
})

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
)
